<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path
      fill="currentColor"
      d="M16.365 1.43c0 1.14-.42 2.09-1.26 2.88-.84.79-1.78 1.25-2.79 1.17-.1-1.09.39-2.12 1.23-2.91.84-.79 1.84-1.25 2.82-1.14.01.33.02.66.02 1zm4.24 16.54c-.29.67-.63 1.29-1.02 1.86-.54.79-1.01 1.33-1.42 1.63-.57.42-1.18.63-1.83.63-.47 0-1.04-.13-1.7-.39-.66-.26-1.27-.39-1.83-.39-.59 0-1.22.13-1.89.39-.67.26-1.23.39-1.68.39-.68 0-1.31-.21-1.89-.63-.42-.3-.9-.84-1.45-1.63-.39-.57-.75-1.2-1.08-1.89-.36-.77-.66-1.67-.9-2.7-.25-1.1-.37-2.13-.37-3.09 0-1.43.31-2.66.93-3.68.62-1.02 1.45-1.53 2.48-1.53.47 0 1.09.15 1.86.45.76.3 1.25.45 1.47.45.15 0 .68-.17 1.59-.51.85-.31 1.57-.44 2.16-.39 1.6.13 2.8.84 3.59 2.13-1.42.86-2.13 2.06-2.13 3.6 0 1.07.4 1.99 1.2 2.76.8.77 1.74 1.16 2.82 1.17-.1.3-.21.6-.33.9z"
    />
  </svg>
</template>

<script setup>
// No additional script needed
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
